<template>
  <v-card>
    <v-card-title class="text-h5" style="word-break: break-word">
      Um fortzufahren akzeptiere bitte unsere Datenschutzerklärung
    </v-card-title>
    <v-card-text>
      <v-card
          class="overflow-y-auto"
          max-height="400"
      >
        <v-card-text>
          <p>
          <h2>Datenschutz</h2>
          <br/>
          <h4>Sehr geehrte Kunden und Geschäftspartner,</h4>
          <br/>
          <p>
            mit den nachfolgenden Angaben möchten wir Sie darüber informieren, wozu wir personenbezogene Daten unserer
            Kunden und Geschäftspartner erheben und wie wir mit diesen Daten umgehen. Die nachfolgende
            Datenschutzerklärung soll Sie auch auf ihre Rechte als Betroffene hinweisen.
            Die meisten dieser Informationen werden Ihnen bereits bekannt sein. Sollten Sie darüber hinaus Fragen zu
            diesem Thema haben, wenden Sie sich bitte an Ihren Ansprechpartner bei Behrendt Consulting GmbH oder
            kontaktieren Sie unseren Datenschutzbeauftragten unter datenschutz@behrendtonline.com.<br/>
            <b>Bitte lesen und bestätigen Sie Ihre Zustimmung zu der unten aufgeführten Datenschutzerklärung durch
              Klicken
              der Taste am Ende der Datenschutzerklärung.<br/>
              Klicken Sie diese Taste nur, wenn Sie mit den hier aufgeführten Informationen einverstanden sind. Sollten
              Sie jedoch nicht mit unserer Datenschutzerklärung einverstanden sein, wenden Sie sich zunächst an unseren
              Datenschutzbeauftragten unter der E-Mail: datenschutz@behrendtonline.com oder den Ansprechpartner Ihrer
              Firma.
            </b>
          </p>
          <br/>
          <h1>Datenschutzerklärung (Schulungsportal)</h1>
          <br/>

          <p>
            <b>(1) Verantwortlich im datenschutzrechtlichen Sinne:<br/>
              Behrendt Consulting GmbH<br/>
              Feldpreul 17<br/>
              61191 Rosbach vor der Höhe</b><br/>
            <b>Telefon:</b> +49 (06003) 82 67 56 – 0<br/>
            <b>Fax:</b> +49 (06003) 82 67 56 – 9<br/>
            <b>E-Mail:</b> info(at)behrendtonline.com<br/>
          </p>

          <p>
            Die Behrendt Consulting GmbH ist eine auf einem Gesellschaftsvertrag beruhende Körperschaft des Privaten
            Rechts. Sie wird gesetzlich vertreten durch den Geschäftsführer Rüdiger Behrendt und die Geschäftsführerin
            Birte Weinstein.<br/>
            Für das Angebot unserer Onlineschulungen nutzen wir die Schulungsplattform https://lms.behrendtonline.com.
            Bei Anfragen oder Beschwerden zum Datenschutz können Sie sich mit dem Datenschutzbeauftragten der Behrendt
            Consulting GmbH in Verbindung setzen.
          </p>
          <br/>

          <p>
            <b>(2) Datenschutzbeauftragte:</b><br/>
            erreichbar unter der gleichen Anschrift:<br/>
            Daniel Kraus<br/>
            <b>Telefon:</b> +49 (06003) 82 67 56 – 0<br/>
            <b>E-Mail:</b> datenschutz@behrendtonline.com
          </p>
          <br/>
          <p>
            <b>(3) Zweck und Folgen der Nichtangabe</b><br/>
            Die E-Learning-Verfahren auf der Lernplattform https://lms.behrendtonline.com der Behrendt Consulting GmbH
            dienen der Vermittlung von Schulungen zur Aus- und Weiterbildung. Die Verarbeitung Ihrer Daten ist zur
            Nutzung der E-Learning-Verfahren auf der Lernplattform https://lms.behrendtonline.com der Behrendt
            Consulting GmbH notwendig. Ohne diese Möglichkeit der Verarbeitung Ihrer Daten kann eine Nutzung nicht
            erfolgen.
          </p>
          <br/>
          <p>
            <b>(4) Rechtsgrundlage</b><br/>
            Wir verarbeiten personenbezogene Daten der Nutzer, der Lernplattform https://lms.behrendtonline.com der
            Behrendt Consulting GmbH, nur unter Einhaltung der einschlägigen Datenschutzbestimmungen. Das bedeutet, die
            Daten der Nutzer werden nur bei Vorliegen einer gesetzlichen Erlaubnis verarbeitet. D.h., insbesondere wenn
            die Datenverarbeitung zur Erbringung unserer vertraglichen Leistungen (z.B. Bearbeitung von Aufträgen) sowie
            Online-Services erforderlich bzw. gesetzlich vorgeschrieben ist, eine Einwilligung der Nutzer vorliegt, als
            auch aufgrund unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und
            wirtschaftlichem Betrieb und Sicherheit unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO,
            insbesondere bei der Reichweitenmessung, Erstellung von Profilen zu Werbe- und Marketingzwecken sowie
            Erhebung von Zugriffsdaten und Einsatz der Dienste von Drittanbietern.<br/>
            Wir weisen darauf hin, dass die Rechtsgrundlage der Einwilligungen Art. 6 Abs. 1 lit. a. und Art. 7 DSGVO,
            die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer Leistungen und Durchführung vertraglicher
            Maßnahmen Art. 6 Abs. 1 lit. b. DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer
            rechtlichen Verpflichtungen Art. 6 Abs. 1 lit. c. DSGVO, und die Rechtsgrundlage für die Verarbeitung zur
            Wahrung unserer berechtigten Interessen Art. 6 Abs. 1 lit. f. DSGVO ist.
          </p>
          <br/>

          <p>
            <b>(5) Kategorien personenbezogener Daten, die verarbeitet werden</b><br/>
            Anmeldedaten:<br/>
            Die Anmeldung und Zuweisung der Schulungen erfolgt durch den jeweiligen Verantwortlichen Ihrer Firma (z.B.
            Sicherheits- oder Gefahrgutbeauftragter).<br/>
            Folgende Daten müssen vom jeweiligen Verantwortlichen der Firma und/oder Ihnen bei der ersten Anmeldung
            (Registrierung) eingegeben werden. Sie werden in unsere Datenbank übertragen und gespeichert:
          <ul>
            <li>Ihr Vorname</li>
            <li>Ihr Nachname</li>
            <li>Ihre E-Mail-Adresse</li>
            <li>Ihr Geburtsdatum (ausschließlich für Schulungen, für die ein behördlich zugelassenes Zertifikat als
              Nachweis
              der erfolgreich abgeschlossenen Schulung erforderlich ist)
            </li>
            <li>Ablaufdatum Ihrer Zuverlässigkeitsüberprüfung (ausschließlich für Luftsicherheitsschulungen)</li>
          </ul>
          <br/>
          Es steht Ihnen frei, bei der Registrierung oder auch später auf Ihrer Profilseite weitere Angaben zu Ihrer
          Person zu machen.<br/>
          Protokolldaten: Bei der Nutzung der Lernplattform werden im Hintergrund Protokolldaten erhoben, insbesondere
          zu welcher Zeit auf welche Bestandteile der Lehrangebote Sie zugreifen, ggf. auch, ob Sie gestellte Aufgaben
          erledigt, sowie ob und wie Sie in Workshops mitgewirkt haben.<br/>
          Nutzerdaten: Weiter werden Daten erhoben, die Sie bei der Nutzung der Lernplattform selbst eingeben. Die
          Verarbeitung der von Ihnen eingegebenen personenbezogenen Daten dient ausschließlich dazu den
          Lernfortschritt zu protokollieren, die gesetzlich geforderten Bescheinigungen und Zertifikate auszustellen
          und die Schulung zu dokumentieren. Die Aufbewahrungsdauer richtet sich nach den gesetzlichen Vorschriften.
          Diese Verarbeitung ist rechtmäßig, weil sie zur Erfüllung des Vertrages gemäß Art. 6 Abs. 1 lit. b DSGVO
          erforderlich ist. Die Speicherung von IP-Adresse und Zeitpunkt der Anmeldung dient dem Zweck die Sicherheit
          unserer informationstechnischen Systeme zu gewährleisten. Hierin liegt zugleich unser berechtigtes
          Interesse, weswegen die Verarbeitung nach Art. 6 Abs. 1 lit. f DSGVO zulässig ist.
          </p>
          <br/>

          <p>
            <b>(6) Empfänger bzw. Kategorien von Empfängern der personenbezogenen Daten</b><br/>
            Die Kategorien von Empfängern Ihrer personenbezogenen Daten sind jeweiliger Verantwortliche Ihrer Firma
            (z.B. Sicherheits- oder Gefahrgutbeauftragte), Behrendt Consulting GmbH (als
            Kursersteller/Schulungsanbieter).
          </p>
          <br/>
          <p>
            <b>(7) Dauer der Speicherung oder Kriterien für die Dauer der Speicherung</b><br/>
            Die Daten in Ihrem Nutzerprofil (Anmeldedaten) werden bis zur Löschung des Nutzerprofils gespeichert. Die
            Daten aus der Teilnahme an Kursen (Nutzerdaten) werden bis zur Löschung des Kurses gespeichert.<br/>
            Protokolldaten werden 30 Tage nach Beendigung des Nutzungsvorgangs gelöscht, es sei denn Rechtsvorschriften
            erlauben oder verlangen ausnahmsweise eine längere Speicherung. Einige Daten im Bereich Luftsicherheit
            werden 5 Jahre lang gespeichert, dies entspricht der Gültigkeitsdauer der Nachweise, wodurch auch die
            Verifizierung der Zertifikate gewährleistet bleibt. Nutzerdaten und freiwillige Einträge im Nutzerprofil
            können Sie jederzeit selbst löschen.
          </p>
          <br/>
          <p>
            <b>(8) Ihre Datenschutzrechte</b><br/>
            Unter bestimmten Voraussetzungen können Sie gegenüber dem/der Verantwortlichen (s.o.) Datenschutzrechte
            geltend machen.<br/>
          <ul>
            <li>So haben Sie das Recht, Auskunft über Ihre in der Lernplattform gespeicherten Daten zu erhalten nach den
              Regeln von Art. 15 DSGVO. Wenn Sie sich auf der Lernplattform einloggen, können Sie ihre Nutzerdaten
              jederzeit selber einsehen.
            </li>
            <li>Auf Ihren Antrag hin werden die über Sie gespeicherten Daten nach Art. 16 DSGVO berichtigt, wenn diese
              unzutreffend oder fehlerhaft sind. Nutzer- und Profildaten können Sie auch selbst korrigieren.
              Wenn Sie es wünschen, werden Ihre Daten nach den Grundsätzen von Art. 17 DSGVO gelöscht, sofern andere
              gesetzliche Regelungen (z. B. gesetzliche Aufbewahrungspflichten) oder ein überwiegendes Interesse des
              Anbieters (z. B. zur Verteidigung unserer Rechte und Ansprüche) dem nicht entgegenstehen. Eine Löschung
              ist
              nicht möglich, wenn Informationen von Ihnen selber erfasst wurden und diese im Kontext mit Informationen
              anderer Nutzer stehen (z.B. Beiträge in Foren und Wikis).
            </li>
            <li>Unter Berücksichtigung der Voraussetzungen des Art. 18 DSGVO können Sie verlangen, die Verarbeitung
              Ihrer
              Daten einzuschränken.
            </li>
            <li>Ferner können Sie gegen die Verarbeitung Ihrer Daten Widerspruch nach Art. 21 DSGVO einlegen, aufgrund
              dessen die Verarbeitung Ihrer Daten beendet werden muss. Dieses Widerspruchsrecht gilt allerdings nur bei
              Vorliegen ganz besonderer Umstände Ihrer persönlichen Situation, wobei Rechte der Behrendt Consulting GmbH
              oder Dritter Ihrem Widerspruchsrecht ggf. entgegenstehen können.
            </li>
            <li>Auch haben Sie das Recht, Ihre bereitgestellten Daten gemäß den Regularien von Art. 20 DSGVO in einem
              strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder Sie einem Dritten zu übermitteln.
              Darüber hinaus haben Sie das Recht, eine erteilte Einwilligung in die Verarbeitung personenbezogener Daten
              jederzeit mit Wirkung für die Zukunft zu widerrufen.
            </li>
            <li>Ferner steht Ihnen ein Beschwerderecht bei einer Datenschutzaufsichtsbehörde zu (Art. 77 DSGVO). Wir
              empfehlen allerdings eine Beschwerde zunächst immer an unsere Datenschutzbeauftragte zu richten.
            </li>
          </ul>
          <br/>
          Ihre Anträge über die Ausübung Ihrer Rechte sollten nach Möglichkeit schriftlich an die oben angegebene
          Anschrift oder direkt an unseren Datenschutzbeauftragten Daniel Kraus adressiert werden.
          </p>
          <br/>
          <p>
            <b>(9) Recht auf Widerruf</b><br/>
            Sie haben das Recht, die Einwilligung zur Verarbeitung Ihrer Daten zu widerrufen. Der Widerruf kann dazu
            führen, dass Sie dann keinen Zugang zur Lernplattform oder einem entsprechenden E-Learning Kurs erhalten.
          </p>
          <br/>
          <p>
            <b>(10) Beschwerderecht bei der zuständigen Aufsichtsbehörde</b><br/>
            Im Falle eines Verstoßes gegen gesetzliche Bestimmungen zum Schutz der über Sie gespeicherten Daten können
            Sie sich an die zuständige Aufsichtsbehörde wenden. Die zuständige Aufsichtsbehörde ist:
            Der Hessische Beauftragte für Datenschutz und Informationsfreiheit Postfach 3163
            65021 Wiesbaden
            Telefon: +49 611 1408 – 0
            E-Mail: Poststelle@datenschutz.hessen.de Website: https://datenschutz.hessen.de/

            Bitte sprechen Sie zuerst den/die Verantwortliche/n bzw. die Datenschutzbeauftragte der Behrendt Consulting
            GmbH an. In den meisten Fällen lassen sich dadurch Fragen klären und Beschwerden lösen.
          </p>
          <br/>
          <p>
            <b>(11) Evtl. Folgen, wenn keine personenbezogenen Daten bereitgestellt werden</b><br/>
            Ohne Ihr Einverständnis zur Verarbeitung ihrer personenbezogenen Daten im Rahmen der E-Learning-Plattform
            durch die Behrendt Consulting GmbH ist eine Nutzung nicht möglich.
          </p>
          <br/>
          <p>
            <b>(12) Herkunft der personenbezogenen Daten</b><br/>
            Die Anmeldedaten, weitere Eingaben in ihr Profil und die Nutzerdaten werden von Ihnen selbst und/oder dem
            jeweiligen Verantwortlichen Ihrer Firma eingegeben. Die Protokolldaten werden automatisch erhoben.
          </p>
          <br/>
          <p>
            <b>(13) Bestehen einer automatisierten Entscheidungsfindung im Einzelfall (einschließlich
              Profiling)</b><br/>
            Wir setzen keine rein automatisierten Entscheidungsverfahren gemäß Art. 22 DSGVO ein. Es erfolgt kein
            Profiling im Sinne der Datenschutzgrundverordnung. Es ist derzeit nicht beabsichtigt, die Daten zu anderen
            als den o.g. Zwecken zu verwenden. Falls die Daten in der Zukunft doch zu anderen Zwecken verwendet werden
            sollen, werden wir Sie vorab informieren.
          </p>
          <br/>
          <p>
            <b>(14) Weitere Verarbeitung für andere Zwecke</b><br/>
            Über die Vermittlung von Onlineschullungen zur Aus- und Weiterbildung im Rahmen E-Learning-Verfahren auf der
            Lernplattform der Behrendt Consulting GmbH verarbeiten wir Ihre Daten gegebenenfalls, wenn es erforderlich
            ist, um berechtigte Interessen von uns oder Dritten zu wahren.<br/>
            Verarbeitungen Ihrer Daten finden nur dann und insoweit statt, als keine überwiegenden Interessen Ihrerseits
            gegen eine entsprechende Verarbeitung sprechen, wie insbesondere für folgende Zwecke:
          <ul>
            <li>Prüfung und Optimierung von Verfahren zur Bedarfsanalyse</li>
            <li>Geltendmachung rechtlicher Ansprüche und Verteidigung bei rechtlichen Streitigkeiten, die nicht
              unmittelbar
              dem Vertragsverhältnis zuzuordnen sind
            </li>
            <li>Weiterentwicklung bestehender Systeme und Prozesse</li>
            <li>Interne und externe Untersuchungen, Sicherheitsüberprüfungen</li>
            <li>Erhalt und Aufrechterhaltung von Zertifizierungen privatrechtlicher oder behördlicher Natur</li>
          </ul>
          </p>
          <br/>
          <p>
            <b>(15) Verwendung von Cookies</b><br/>
            Mit der Nutzung von Moodle werden zwei Cookies auf dem von Ihnen benutzten Computer gespeichert. Die Cookies
            mit den Namen "MoodleSession" und "MoodleSessionTest" sind Session-Cookies, die nach Schließen Ihres
            Browsers gelöscht werden.<br/>
            Rechtsgrundlage für die Datenverarbeitung ist Ihre Einwilligung (Art. 6 Abs. 1 lit a DSGVO).
            Zweck der Datenverarbeitung: Die beiden Cookies sind notwendig, um den Zugriff nach dem Login auf alle
            Seiten zu ermöglichen.<br/>
            Dauer der Speicherung, Widerspruchs- und Beseitigungsmöglichkeit: Cookies werden auf ihrem Rechner
            gespeichert und von diesem an unserer Seite übermittelt. Daher haben Sie als Nutzer auch die volle Kontrolle
            über die Verwendung von Cookies. Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie
            die Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte Cookies können jederzeit
            gelöscht werden. Dies kann auch automatisiert erfolgen. Sie können Moodle jedoch nur verwenden, wenn Sie in
            ihrem Browser Cookies zumindest temporär zulassen. Nach Schließen Ihres Browsers werden die Cookies
            gelöscht.
          </p>
          <br/>
          <p>
            <b>(16) Einwilligung</b><br/>
            Mit der Registrierung und Nutzung des Moodle-Systems geben Sie in Kenntnis dieser Erläuterungen Ihre
            Einwilligung zu der bezeichneten Erhebung und Verarbeitung der Daten.
          </p>
          <br/>
          <p>
            <b>(17) Erklärung</b><br/>
            Hiermit erkläre ich, dass ich die Kursmaterialien der von mir gebuchten oder mir – durch meinen Arbeitgeber
            – zugeordneten Kurse nicht an unbeteiligte Dritte weitergeben werde. Für Verletzungen dieser Pflichten bin
            ich selbst verantwortlich.<br/><br/>

            Zuletzt geändert: Mittwoch, 08. Juni 2022, 15:38
          </p>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-actions>
      <v-btn
          text
          @click="accept">
        Akzeptieren
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "PrivacyDialog",
  data: () => ({
    show: false,
  }),
  methods: {
    accept() {
      this.$emit("accepted")
    }
  }
}
</script>

<style scoped>

</style>
